import { useMediaQuery, useTheme } from "@mui/material";


export default function ContainerApostas({ bgImg, content, title, reverse }) {

    const theme = useTheme();
    const matchesMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (

        <div style={{
            width: '100%',
            background: 'linear-gradient(90deg, #47E4A6, #4CCEDD 100%)',
            padding: '1px',
            borderRadius: '16px',
            display: 'flex'
        }}>
            <div style={{
                backgroundColor: '#191919',
                display: 'flex',
                borderRadius: '16px',
                flexDirection: matchesMobile ? 'column' : 'row' && reverse && 'row-reverse'
            }}>
                <div style={{

                    borderRadius: '16px',
                    padding: matchesMobile ? '24px 16px' : '86px 24px',
                    fontFamily: 'Manrope',
                    width: matchesMobile ? '100%' : '50%',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: matchesMobile ? 16 : 40
                }}>
                    <p
                        className={`${'revalida'} gradient-text`}
                        style={{
                            fontWeight: 800,
                            fontSize: matchesMobile ? 24 : 32
                        }}>
                        {title}
                    </p>
                    <p style={{
                        fontWeight: 500,
                        fontSize: matchesMobile ? 16 : 20,
                        color: '#E6E6E6'
                    }}>
                        {content}
                    </p>
                </div>
                <div style={{
                    width: matchesMobile ? '100%' : '50%',
                    display: 'flex',
                    alignItems: 'flex-end'
                }}>
                    <img src={bgImg} alt="" />
                </div>
            </div>

        </div>
    )
}